import z from "zod";

export const commentSchema = z
  .object({
    rate: z.number().optional(),
    text: z.string().min(5, "نظر باید حداقل ۵ کاراکتر باشد"),
    lesson: z.number(),
  })
  .refine((data) => data.rate !== undefined && data.rate >= 1, {
    message: "لطفاً امتیاز خود را وارد کنید",
    path: ["rate"],
  });

export type CommentFormData = z.infer<typeof commentSchema>;
